import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { Leaf } from "lucide-react";

export function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="mt-20 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 text-primary font-display font-extrabold text-lg"><Leaf className="w-6 h-6" /> {settings?.shop_name || "Herbalife Shop"}</div>
          <p className="mt-3 text-sm text-slate-500 max-w-xs leading-relaxed">Negozio online di un distributore indipendente Herbalife. Non è un sito ufficiale Herbalife.</p>
        </div>
        <div>
          <h4 className="font-semibold text-slate-900 mb-3">Naviga</h4>
          <ul className="space-y-2 text-sm text-slate-500">
            <li><Link to="/catalogo" className="hover:text-primary">Catalogo</Link></li>
            <li><Link to="/categorie" className="hover:text-primary">Categorie</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-primary">Chi siamo</Link></li>
            <li><Link to="/herbalife-rossano" className="hover:text-primary">Herbalife a Rossano</Link></li>
            <li><Link to="/faq" className="hover:text-primary">FAQ</Link></li>
            <li><Link to="/contatta-il-distributore" className="hover:text-primary">Contatta il distributore</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-slate-900 mb-3">Info</h4>
          <ul className="space-y-2 text-sm text-slate-500">
            <li><Link to="/spedizioni" className="hover:text-primary">Spedizione e consegna</Link></li>
            <li><Link to="/privacy" className="hover:text-primary">Privacy Policy</Link></li>
            <li><Link to="/termini" className="hover:text-primary">Termini e Condizioni</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-100 py-4 text-center text-xs text-slate-400">© {new Date().getFullYear()} {settings?.shop_name || "Herbalife Shop"} — Distributore indipendente Herbalife · Tutti i diritti riservati</div>
    </footer>
  );
}
